import constants from './constants';
import { createFailure, createRequest, createSuccess } from 'ducks/helpers';


export const siteEmailSettingsRequest = createRequest(constants.SITE_EMAIL_SETTINGS);
export const siteEmailSettingsSuccess = createSuccess(constants.SITE_EMAIL_SETTINGS);
export const siteEmailSettingsFailure = createFailure(constants.SITE_EMAIL_SETTINGS);

export const updateSiteEmailSettingRequest = createRequest(constants.UPDATE_SITE_EMAIL_SETTING);
export const updateSiteEmailSettingSuccess = createSuccess(constants.UPDATE_SITE_EMAIL_SETTING);
export const updateSiteEmailSettingFailure = createFailure(constants.UPDATE_SITE_EMAIL_SETTING);

export const siteEmailRecipientsRequest = createRequest(constants.SITE_EMAIL_RECIPIENTS);
export const siteEmailRecipientsSuccess = createSuccess(constants.SITE_EMAIL_RECIPIENTS);
export const siteEmailRecipientsFailure = createFailure(constants.SITE_EMAIL_RECIPIENTS);

export const updateSiteEmailRecipientsRequest = createRequest(constants.UPDATE_SITE_EMAIL_RECIPIENTS);
export const updateSiteEmailRecipientsSuccess = createSuccess(constants.UPDATE_SITE_EMAIL_RECIPIENTS);
export const updateSiteEmailRecipientsFailure = createFailure(constants.UPDATE_SITE_EMAIL_RECIPIENTS);

export const requestSiteEmailSettings = siteEmailSettingsRequest;
export const updateSiteEmailSetting = updateSiteEmailSettingRequest;
export const requestSiteEmailRecipients = siteEmailRecipientsRequest;
export const updateSiteEmailRecipients = updateSiteEmailRecipientsRequest;
